"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_store_1 = require("owa-options-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var escapeRegExp = require("lodash/escapeRegExp");
exports.default = legacy_1.select({
    options: function () { return owa_options_store_1.getAllOptions(); },
})(function filterOptions(searchTerm, state) {
    if (!searchTerm) {
        return null;
    }
    var searchRegex = RegExp(escapeRegExp(searchTerm.trim()), 'i');
    return state.options.filter(function (option) {
        return owa_options_strings_1.default[option.searchTermsStringKey].match(searchRegex);
    });
});
//# sourceMappingURL=filterOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/utils/filterOptions.js
// module id = 3774
// module chunks = 2